import { useEffect, useState } from 'react';
import CardProduct from '../../card/CardProduct/CardProduct';
import LeftMenuDesign from '../../common/LeftMenuDesign/LeftMenuDesign';
import { useDispatch, useSelector } from 'react-redux';
import { fetchInsideAccessories } from '../../../store/actions/insideAccessory.action';
import { getValueFromString } from '../../../utils/data/getValue.utils';
import DropdownFilter from '../../common/DropdownFilter/DropdownFilter';
import ButtonIconOutlineMedium from '../../common/ButtonIconOutline/ButtonIconOutlineMedium';
import SearchComponent from '../../common/SearchComponent/SearchComponent';
import ButtonIconGhostMedium from '../../common/ButtonIconGhost/ButtonIconGhostMedium';

const LeftLightingCustomDesignMenu = ({
  open,
  onDragStart,
  title,
  productType,
  sceneManager,
}) => {
  const dispatch = useDispatch();
  const { insideAccessories } = useSelector(state => state.insideAccessory);
  const [keyWord, setKeyWord] = useState('');

  // Fetch khi product_type đổi (lần đầu + mọi lần đổi)
  useEffect(() => {
    if (!productType) return;
    dispatch(fetchInsideAccessories(productType));
  }, [dispatch, productType]);

  // Nếu nơi khác set cờ reload, fetch lại với productType hiện tại
  useEffect(() => {
    if (!productType) return;
    if (insideAccessories?.isNeedReloadData) {
      dispatch(fetchInsideAccessories(productType));
    }
  }, [dispatch, productType, insideAccessories?.isNeedReloadData]);

  const lightings = insideAccessories?.data?.lightings ?? [];

  return (
    <LeftMenuDesign
      open={open}
      classNames={{
        root: '!left-[72px] relative',
        content: '!p-0 gap-0',
      }}
      header={
        <div className={'flex flex-col gap-4 self-stretch grow'}>
          <span className="text-title-large text-nowrap">{title}</span>
          <div className="left-accessory-custom-design-menu-header-actions bg-fills-white">
            <div className="flex self-stretch py-[2px]">
              <SearchComponent
                value={keyWord}
                setValue={setKeyWord}
                size="small"
                styles={{ input: { width: '100%' } }}
                className={'grow'}
              />
            </div>
          </div>
        </div>
      }
      content={
        <>
          <div className="grid grid-cols-2 p-8 items-start align-content-start gap-2 self-stretch">
            {lightings
              ?.filter(
                item => item.name.includes(keyWord) || keyWord.trim() === ''
              )
              ?.map((md, i) => {
                const name = getValueFromString(md.name);
                const description = getValueFromString(md.description ?? '');

                return (
                  <CardProduct
                    key={i}
                    md={md}
                    title={name}
                    description1={description}
                    description2={
                      md.width && md.depth && md.height
                        ? `R${md.width ?? '--'} * S${md.depth ?? '--'} * C${
                            md.height ?? '--'
                          }`
                        : null
                    }
                    moduleType={i}
                    onDragStart={onDragStart}
                  />
                );
              })}
          </div>
        </>
      }
    />
  );
};

export default LeftLightingCustomDesignMenu;
